import { useState, useEffect } from 'react';
import { getValue } from 'firebase/remote-config';
import { fetchRemoteConfig, remoteConfig } from '../config/firebase.ts';

type FeatureFlagValue = boolean | string | number;

interface UseFeatureFlagResult<T extends FeatureFlagValue> {
  value: T;
  loading: boolean;
}

export function useFeatureFlag<T extends boolean>(flagName: string, defaultValue: T): UseFeatureFlagResult<T>;
export function useFeatureFlag<T extends string>(flagName: string, defaultValue: T): UseFeatureFlagResult<T>;
export function useFeatureFlag<T extends number>(flagName: string, defaultValue: T): UseFeatureFlagResult<T>;

export function useFeatureFlag<T extends FeatureFlagValue>(flagName: string, defaultValue: T): UseFeatureFlagResult<T> {
  const [value, setValue] = useState<T>(defaultValue);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadFlag = async (): Promise<void> => {
      setLoading(true);

      await fetchRemoteConfig();

      try {
        const remoteValue = getValue(remoteConfig, flagName);

        if (typeof defaultValue === 'boolean') {
          setValue(remoteValue.asBoolean() as T);
        } else if (typeof defaultValue === 'number') {
          setValue(remoteValue.asNumber() as T);
        } else {
          setValue(remoteValue.asString() as T);
        }
      } catch (error) {
        console.error(`Erro ao obter flag ${flagName}:`, error);
        setValue(defaultValue);
      } finally {
        setLoading(false);
      }
    };

    loadFlag();
  }, [flagName, defaultValue]);

  return { value, loading };
}
